import { BehaviorSubject } from 'rxjs';
import useBehaviorSubject from '../../../functions/hooks/useBehaviorSubject';

export const isSellerApplicationFlowActive$ = new BehaviorSubject<boolean>(
  false,
);

export const useIsSellerApplicationFlowActive = () =>
  useBehaviorSubject(isSellerApplicationFlowActive$)[0];
